import { useRef } from "react";
import { useRole } from "../../../contexts/RoleContext";
import { useState } from "react";
import { IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import {
  CloudUpload as CloudUploadIcon,
  CreateNewFolder as CreateNewFolderIcon,
  Add as AddIcon,
  SelectAll as SelectAllIcon,
  Delete as DeleteIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import { useFileActions } from "../../../contexts/FileActionsContext";

function ActionButton() {
  const { isAdmin } = useRole();
  const {
    uploading,
    setNewFolderDialogOpen,
    handleFileUpload,
    selectedFiles,
    handleDeleteSelectedFiles,
    files,
    handleSelectAll,
    downloadSelectedAsZip,
  } = useFileActions();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const inputRef = useRef(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        edge="start"
        aria-label="menu"
        onClick={handleMenuClick}
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#1565c0",
          },
        }}
      >
        <AddIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        transitionDuration={0}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        {isAdmin() && (
          <MenuItem
            component="label"
            htmlFor="file-upload-input"
            disabled={uploading}
            onClick={() => {
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <CloudUploadIcon fontSize="small" />
            </ListItemIcon>
            {uploading ? "Enviando..." : "Upload"}
          </MenuItem>
        )}

        {isAdmin() && (
          <MenuItem
            onClick={() => {
              setNewFolderDialogOpen(true);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <CreateNewFolderIcon fontSize="small" />
            </ListItemIcon>
            Nova Pasta
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            handleSelectAll(true);
            handleMenuClose();
          }}
        >
          <ListItemIcon>
            <SelectAllIcon fontSize="small" />
          </ListItemIcon>
          {selectedFiles.length === files.length
            ? "Desmarcar Todos"
            : "Selecionar Todos"}
        </MenuItem>
        {selectedFiles.length > 0 && (
          <MenuItem
            onClick={() => {
              downloadSelectedAsZip();
              handleMenuClose();
            }}
            disabled={selectedFiles.length === 0}
          >
            <ListItemIcon>
              <DownloadIcon fontSize="small" />
            </ListItemIcon>
            Download Selecionados ({selectedFiles.length})
          </MenuItem>
        )}
        {selectedFiles.length > 0 && (
          <MenuItem
            onClick={() => {
              handleDeleteSelectedFiles(true);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            Excluir ({selectedFiles.length})
          </MenuItem>
        )}
      </Menu>
      {isAdmin() && (
        <input
          id="file-upload-input"
          type="file"
          ref={inputRef}
          multiple
          style={{
            position: "fixed",
            top: -10000,
            left: -10000,
            opacity: 0,
            width: "1px",
            height: "1px",
            overflow: "hidden",
            zIndex: -1,
          }}
          onChange={(e) => {
            handleFileUpload(e);
          }}
        />
      )}
    </>
  );
}

export default ActionButton;
